import { AbstractControl, ValidationErrors } from '@angular/forms';

export abstract class NumbersValidator {
  private static readonly REGEX_ONLY_NUBERS_AND_SPACES = /^[\d- ]*$/;
  private static readonly REGEX_ONLY_NUBERS = /^[\d]*$/;

  static onlyNumbersDashAndSpaces(control: AbstractControl): ValidationErrors {
    if (!control || !control.value) {
      return null;
    }
    const value = control.value;

    const regExp = new RegExp(NumbersValidator.REGEX_ONLY_NUBERS_AND_SPACES);

    return regExp.test(value) ? null : { onlyNumbersDashAndSpaces: { valid: false } };
  }

  static onlyNumbers(control: AbstractControl): ValidationErrors {
    if (!control || !control.value) {
      return null;
    }
    const value = control.value;

    const regExp = new RegExp(NumbersValidator.REGEX_ONLY_NUBERS);

    return regExp.test(value) ? null : { onlyNumbers: { valid: false } };
  }
}
